import { getWindowInBrowser } from 'client/RuntimeWindow';
import { useEffect, useState } from 'react';
import { context } from '@shared-services/context-service';
import { CalBookingProps } from '../RuntimeCalBooking';
import { UrlAction } from '../types';

interface UseBookerPropsProps extends CalBookingProps {
    setRescheduleUid: (uid: string) => void;
    setCancelBookingId: (uid: string) => void;
}

interface ExpectedUrlParams {
    slug: string;
    action: UrlAction;
    teamId: number;
    bookingUid: string;
    username: string;
}

interface UseBookerPropsReturn extends CalBookingProps {
    isCancelAction?: boolean;
    isRescheduleAction?: boolean;
    bookingUid?: string;
}

export const useBookerProps = (
    props: UseBookerPropsProps
): UseBookerPropsReturn => {
    const [
        {
            slug: urlSlug,
            action: urlAction,
            teamId: urlTeamId,
            bookingUid,
            username: urlUsername,
            isUrlAction,
        },
    ] = useState(() => {
        const params = resolveUrlParams();
        return {
            ...params,
            isUrlAction: [UrlAction.RESCHEDULE, UrlAction.CANCEL].includes(
                params.action as UrlAction
            ),
        };
    });

    const isCancelAction = urlAction === UrlAction.CANCEL;
    const isRescheduleAction = urlAction === UrlAction.RESCHEDULE;

    useEffect(() => {
        if (bookingUid) {
            if (urlAction === UrlAction.RESCHEDULE) {
                props.setRescheduleUid(bookingUid);
            }
            if (urlAction === UrlAction.CANCEL) {
                props.setCancelBookingId(bookingUid);
            }
        }
    }, []);

    if (isUrlAction) {
        return {
            ...props,
            eventSlug: urlSlug || props.eventSlug,
            teamId: urlTeamId || props.teamId,
            userName: urlUsername || props.userName,
            isCancelAction,
            isRescheduleAction,
            bookingUid,
        };
    }

    return props;
};

function resolveUrlParams(clearUrl = true) {
    if (context.isServer) {
        return {
            slug: undefined,
            action: undefined,
            teamId: undefined,
            bookingUid: undefined,
            username: undefined,
            isUrlAction: false,
        };
    }

    const urlParams = new URLSearchParams(getWindowInBrowser().location.search);
    if (clearUrl) {
        setTimeout(() => {
            history.replaceState(
                null,
                '',
                getWindowInBrowser().location.pathname
            );
        }, 0);
    }

    return Object.fromEntries(
        urlParams.entries()
    ) as unknown as ExpectedUrlParams;
}
